import { Controller, useFormContext } from "react-hook-form";

import { View } from "react-native-ui-lib";
import { Label, TextField } from "@towersystems/roam-common-native";
import { AddCartNonMatchingProductFormValues } from "../types";
import { useTranslation } from "react-i18next";

export interface CostPriceFormInputProps {}

export const CostPriceFormInput = ({}: CostPriceFormInputProps) => {
  const { control } = useFormContext<AddCartNonMatchingProductFormValues>();
  const { t } = useTranslation("pos");
  return (
    <View>
      <Label required label={t("form.costPrice.label")}></Label>
      <Controller
        name="costPrice"
        control={control}
        render={({
          field: { onChange, value, onBlur },
          fieldState: { error },
        }) => (
          <TextField
            onChangeText={onChange}
            onBlur={onBlur}
            value={value ?? ""}
            validationMessage={error ? error.message : undefined}
            placeholder={t("form.costPrice.placeholder")}
            formatterType={error?.message ? undefined : "money"}
          />
        )}
      />
    </View>
  );
};
